import React from 'react';
import { withRouter } from 'react-router-dom';
import { Pagination } from 'antd';
import Enums from 'utils/EnumsManager';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { FormattedMessage } from 'react-intl';
import { getThemeByType } from 'utils/common';
import { Panel, BackToPrev } from 'components/ui/index';
import { tryFetchModuleData } from 'components/page/DetailsSubpanels/flow/actions';
import TaskDetailCard from '../components/TaskDetailCard';
import styles from '../index.less';

const cx = classNames.bind(styles);

const { DetailModules, DefaultPageConfigs } = Enums;
const { TaskHistory } = DetailModules;
const { PageSize } = DefaultPageConfigs;

const propTypes = {
  taskHistory: PropTypes.object,
  objectId: PropTypes.string.isRequired,
  objectType: PropTypes.string.isRequired,
};

const defaultProps = {
  taskHistory: {},
};

class ObjectTaskViewAll extends React.Component {
  componentDidMount() {
    const { objectType, objectId, tryFetchModuleData } = this.props;
    tryFetchModuleData(TaskHistory, objectType, objectId, { page: 1, per_page: PageSize });
  }

  handlePageChange = (page, pageSize) => {
    const { objectType, objectId, tryFetchModuleData } = this.props;
    tryFetchModuleData(TaskHistory, objectType, objectId, { page, per_page: pageSize });
  }

  render() {
    const {
      taskHistory,
      objectType,
      objectId,
      settings,
    } = this.props;
    const theme = getThemeByType(objectType);
    const { meta, data } = taskHistory;

    return (
      <React.Fragment>
        <BackToPrev
          backLink={`/${objectType}/${objectId}`}
          backText={<FormattedMessage id="global.ui.button.backTo" values={{ backToPage: objectType }} />}
        />
        <Panel
          panelClasses={`${theme}-theme-panel pb-lg mt-sm`}
          contentClasses="pr-lg pl-lg"
        >
          <div className={classNames(cx('tasks-panel-title'), 'mb-sm', 'mt-sm')}>
            <FormattedMessage id="global.ui.button.viewAll" />
          </div>
          {_.isArray(data) && !_.isEmpty(data) &&
            taskHistory.data.map(task => (
              <TaskDetailCard
                key={task.id}
                taskData={task}
                prioritiesList={settings.priorities}
                statusesList={settings.statuses}
              />
            ))
          }
          <Pagination
            size="small"
            className="tasks-all-pagination"
            total={meta && !_.isEmpty(meta.pagination) ? meta.pagination.total : 0}
            defaultPageSize={PageSize}
            showTotal={(total, range) => `${range[0]}-${range[1]} / ${total}`}
            onChange={(page, pageSize) => this.handlePageChange(page, pageSize)}
          />
        </Panel>
      </React.Fragment>
    );
  }
}

ObjectTaskViewAll.defaultProps = defaultProps;
ObjectTaskViewAll.propTypes = propTypes;

const mapStateToProps = ({ global, clientDetails }) => ({
  language: global.language,
  settings: global.settings,
  taskHistory: clientDetails.subpanels.TaskHistory,
});
const mapDispatchToProps = {
  tryFetchModuleData,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ObjectTaskViewAll));



// WEBPACK FOOTER //
// ./src/views/ObjectTask/container/ObjectTaskViewAll.jsx